<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">充电记录</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnCharging"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">充电订单</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('CREATE_TIME',$event)"
                      >#</th>
                      
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width: 120px;"
                        @click="getList('CHARGE_ORDER_ID',$event)"
                      >订单号</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width: 120px;"
                        @click="getList('CELL_NAME',$event)"
                      >适用范围</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width: 120px;"
                        @click="getList('CHARGING_PILE_SN',$event)"
                      >设备号</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="width: 80px; min-width:80px"
                        @click="getList('PORT_ID',$event)"
                      >端口号</th>
                      <th
                        class="text-left sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('ORDER_TYPE',$event)"
                      >充电类型</th>
                      <th
                          class="text-left d-xl-table-cell sorting"
                          @click="getList('CHARGE_START_TIME',$event)"
                          style="min-width:140px;"
                        >开始时间</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          @click="getList('CHARGE_END_TIME',$event)"
                          style="min-width:140px;"
                        >结束时间</th>
                      <th
                        class="text-left sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('CHARGING_MINUTE',$event)"
                      >充电时长</th>
                      <th
                        class="text-left sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('BILLING_TOTAL_MINUTE',$event)"
                      >计费时长</th>
                      <th
                        class="text-left sorting"
                        style="width: 120px; min-width:120px"
                        @click="getList('TOTAL_FEE',$event)"
                      >已扣金额</th>
                      <th
                        class="text-left sorting"
                        style="width: 95px; min-width:95px"
                        @click="getList('PACKET_MINUTE',$event)"
                      >已扣时长</th>
                      <th
                        class="text-left sorting"
                        style="width: 115px; min-width:115px"
                        @click="getList('AVG_ELECTRICITY ',$event)"
                      >
                        检测电流
                        <!-- (mA) -->
                      </th>
                      <th
                        class="text-left sorting"
                        style="width: 115px; min-width:115px"
                        @click="getList('END_ELECTRICITY ',$event)"
                      >
                        结束电流
                        <!-- (mA) -->
                      </th>
                      <th
                          class="text-left d-xl-table-cell sorting"
                          @click="getList('END_INFO',$event)"
                          style="min-width:140px;"
                        >结束原因</th>
                      <!-- <th
                        class="text-center sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('CHARGE_STATE ',$event)"
                      >订单状态</th>-->
                    </tr>
                  </thead>
                  <tbody v-if="agents.length">
                    <tr v-for="(item, i) in agents" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left">
                          <div class="text-over" style="width:100px">{{ item.CHARGE_ORDER_ID }}</div>
                        </td>
                        <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                        <td class="text-left d-xl-table-cell">
                          <div class="text-over" style="width:85px">{{ item.CHARGING_PILE_SN}}</div>
                        </td>
                        <td class="text-left d-xl-table-cell">{{ item.PORT_ID }}</td>
                        <td class="text-left">{{ showType(item.ORDER_TYPE) }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CHARGE_START_TIME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CHARGE_END_TIME }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.CHARGE_MINUTE }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.BILLING_TOTAL_MINUTE }}</td>
                        <td class="text-left d-xl-table-cell">{{ changeTwoDecimal(item.FEE) }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.PACKET_MINUTE }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.AVG_ELECTRICITY }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.END_ELECTRICITY }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.END_INFO }}</td>
                      <!-- <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <span
                          class="badge badge-pill"
                          :class="{'badge-secondary':item.CHARGE_STATE =='2','badge-success':item.CHARGE_STATE !='2'}"
                        >{{item.CHARGE_STATE =="2"?"已完成":"进行中" }}</span>
                      </td>-->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="16">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="agents && agents.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    this.getList();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    showType(val) {
      switch (val) {
        case "1":
          return "智能充";
        case "2":
          return "测试订单";
        case "3":
          return "检测订单";
        case "4":
          return "时长充";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/User/GetUserOrder/${this.$route.params.id}/${this.page}/${this.pageSize}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/User/GetUserOrder/${this.$route.params.id}/${this.page}/${this.pageSize}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[1].innerText;
      var btn = document.getElementById("copybtnCharging");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>